import React from "react";

const BasicImage: React.FC<any> = ({ src, ...restProps }) => {
  return <img src={process.env.REACT_APP_FILE_URL + src} {...restProps} />;
};

export default BasicImage;
